var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"post-detail-container"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.postDetail.title))]),_c('div',{staticClass:"post-detail",domProps:{"innerHTML":_vm._s(_vm.postDetail.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }